<template>
    <div>
        <div class="layui-card-header">
            <blockquote class="layui-elem-quote">
                个人信息
            </blockquote>
        </div>
        <div class="layui-card-body">
            <div class="u-gx-ttop f-cb">
                <div class="f-fl f-f0 f-fc9 tipinfo">绝不会以任何形式向第三方透漏你的身份信息</div>
            </div>
            <div class="info-settings f-cb" id="personal-info-settings">
                <div class="personal-info-setting-head-wrapper">
                    <div class="input-row-wrapper">
                        <div class="input-row-left personal-info-setting-head-profile-image-label-wrapper">
                            <label class="">头&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;像</label>
                        </div>
                        <div class="input-row-right adjust-upward">
                            <div class="profile-image-wrapper">
                                <a class="profile-image-upload">
                                    <img style="height: 135px;width: 105px;border-radius: 60px;" class="profile-image"
                                        :src="headPath" alt="个人头像">
                                    <div>
                                        <div class="profile-image-upload-btn">
                                            <el-upload :action="action" :show-file-list="false"
                                                :on-success="successFile">
                                                <span>编辑头像</span>
                                            </el-upload>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="input-row-wrapper" style="margin-top: 30px;">
                        <div class="input-row-left">
                            <label class="
                                        personal-info-setting-body-real-name-label">
                                姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名
                            </label>
                        </div>
                        <div class="input-row-right adjust-upward">
                            <div>
                                <label class="ux-input2 input-box">
                                    <input type="text" class="ux-input ux-input_normal ux-input_base ux-input_"
                                        placeholder="" v-model="userName">
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="personal-info-setting-body-wrapper">
                    <!-- 手机号 -->
                    <div class="input-row-wrapper">
                        <div class="input-row-left">
                            <label class="">手机帐号</label>
                        </div>
                        <div class="input-row-right align-middle">
                            <div>
                                <label class="ux-input2 input-box">
                                    <input v-model="telephone" type="text"
                                        class="ux-input ux-input_normal ux-input_base ux-input_" placeholder="">
                                </label>
                            </div>
                            <div class="personal-info-setting-body-real-name-tip f-fc9" style="color: red;">
                                <i class="layui-icon layui-icon-tips"></i>用于申报过程中与资料审核人员进行联系
                            </div>
                        </div>
                    </div>
                    <!-- 身份证号 -->
                    <div class="input-row-wrapper">
                        <div class="input-row-left">
                            <label class=" personal-info-setting-body-real-name-label">
                                身份证号
                            </label>
                        </div>
                        <div class="input-row-right adjust-upward">
                            <div>
                                <label class="ux-input2 input-box" style="font-size: 14px;">
                                    {{idCard}}
                                </label>
                            </div>
                            <div class="personal-info-setting-body-real-name-tip f-fc9" style="color: red">
                                <i class="layui-icon layui-icon-tips"></i>身份证号为识别用户唯一标识，一经注册不可修改。
                            </div>
                        </div>
                    </div>
                    <!-- 国徽面 -->
                    <div class="input-row-wrapper">
                        <div class="input-row-left">
                            <label class=" personal-info-setting-body-real-name-label">
                                身份证国徽面
                            </label>
                        </div>
                        <div class="input-row-right adjust-upward">
                            <el-upload :action="actionCardImageUrl" :show-file-list="false" :drag="true"
                                :on-success="successFileIdCardFront">
                                <div class="layui-upload-drag" id="uploadIdCardFront-btn">
                                    <i class="layui-icon layui-icon-upload"></i>
                                    <p>点击上传，或将图片拖拽到此处</p>
                                    <div class="layui-show" id="uploadIdCardFront">
                                        <hr>
                                        <img v-if="idCardFrontFlag" src='../../../static/img/idCardFront.jpg'
                                            alt="身份证国徽面" style="max-width: 196px">

                                        <img v-if="!idCardFrontFlag" :src='idCardFront' alt="身份证国徽面"
                                            style="max-width: 196px">
                                    </div>
                                </div>
                            </el-upload>

                            <div class="personal-info-setting-body-real-name-tip f-fc9" style="color: red">
                                <i class="layui-icon layui-icon-tips"></i>图片大小不得超过1mb。
                            </div>
                        </div>
                    </div>
                    <!-- 正面     -->
                    <div class="input-row-wrapper">
                        <div class="input-row-left">
                            <label class=" personal-info-setting-body-real-name-label">
                                身份证人物面
                            </label>
                        </div>
                        <div class="input-row-right adjust-upward">
                            <div class="profile-image-wrapper">
                                <el-upload :action="actionCardImageUrl" :show-file-list="false" :drag="true"
                                    :on-success="successFileIdCardReverse">
                                    <div class="layui-upload-drag" id="uploadIdCardReverse-btn">
                                        <i class="layui-icon layui-icon-upload"></i>
                                        <p>点击上传，或将文件拖拽到此处</p>
                                        <div class="layui-show" id="uploadDemoView">
                                            <hr>
                                            <img v-if="idCardReverseFlag" src="../../../static/img/idCardReverse.jpg"
                                                alt="上传成功后渲染" style="max-width: 196px">
                                            <img v-if="!idCardReverseFlag" :src="idCardReverse"
                                                style="max-width: 196px">
                                        </div>
                                    </div>
                                </el-upload>
                            </div>
                            <div class="personal-info-setting-body-real-name-tip f-fc9" style="color: red">
                                <i class="layui-icon layui-icon-tips"></i>图片大小不得超过1mb。
                            </div>
                        </div>
                    </div>
                    <!-- 邮箱 -->
                    <div class="input-row-wrapper">
                        <div class="input-row-left">
                            <label class="personal-info-setting-body-real-name-label">
                                邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱
                            </label>
                        </div>
                        <div class="input-row-right adjust-upward">
                            <div>
                                <label class="ux-input2 input-box">
                                    <input v-model="email" type="text"
                                        class="ux-input ux-input_normal ux-input_base ux-input_" placeholder="">
                                </label>
                            </div>
                            <div class="personal-info-setting-body-real-name-tip f-fc9" style="color: red">
                                <i class="layui-icon layui-icon-tips"></i>用于找回密码。
                            </div>
                        </div>
                    </div>
                    <!-- 性别 -->
                    <div class="input-row-wrapper">
                        <div class="input-row-left">
                            <label>性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别</label>
                        </div>
                        <div class="input-row-right">
                            <div class="layui-input-block" style="margin-left: 0;">
                                <el-radio-group size="medium" v-model="sex">
                                    <el-radio  label="1">男</el-radio>
                                    <el-radio  label="2">女</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="personal-info-setting-foot-wrapper">
                    <!-- 最高学历 -->
                    <div class="input-row-wrapper highest-degree-wrapper">
                        <div class="input-row-left">
                            <label>最高学历</label>
                        </div>
                        <div class="input-row-right">
                            <el-radio-group size="medium" v-model="education">
                                <div class="layui-input-block" style="margin-left: 0;">
                                    <el-radio  label="博士">博士</el-radio>
                                    <el-radio  label="研究生">研究生</el-radio>
                                    <el-radio  label="本科">本科</el-radio>
                                    <el-radio  label="专科">专科</el-radio>
                                </div>
                                <div class="layui-input-block" style="margin-left: 0;">
                                    <el-radio  label="高中">高中</el-radio>
                                    <el-radio  label="初中">初中</el-radio>
                                    <el-radio  label="小学">小学</el-radio>
                                    <el-radio  label="其他">其他</el-radio>
                                </div>
                            </el-radio-group>
                        </div>
                    </div>
                    <!-- 所学专业 -->
                    <div class="input-row-wrapper highest-degree-wrapper">
                        <div class="input-row-left">
                            <label>所学专业</label>
                        </div>
                        <div class="input-row-right">
                            <label class="ux-input2 input-box">
                                <input v-model="major" type="text"
                                    class="ux-input ux-input_normal ux-input_base ux-input_" placeholder=""
                                    maxlength="10">
                            </label>
                        </div>
                    </div>
                    <!-- 政治面貌 -->
                    <div class="input-row-wrapper highest-degree-wrapper">
                        <div class="input-row-left">
                            <label>政治面貌</label>
                        </div>
                        <div class="layui-input-inline" style="margin-left: 0;padding-top: 13px;">
                            <el-select size="medium" v-model="politic_countenance" placeholder="请选择">
                                <el-option label="中共党员" value="中共党员">中共党员</el-option>
                                <el-option label="中共预备党员" value="中共预备党员">中共预备党员</el-option>
                                <el-option label="共青团员" value="共青团员">共青团员</el-option>
                                <el-option label="民革党员" value="民革党员">民革党员</el-option>
                                <el-option label="民盟盟员" value="民盟盟员">民盟盟员</el-option>
                                <el-option label="民建会员" value="民建会员">民建会员</el-option>
                                <el-option label="民进会员" value="民进会员">民进会员</el-option>
                                <el-option label="农工党党员" value="农工党党员">农工党党员</el-option>
                                <el-option label="致公党党员" value="致公党党员">致公党党员</el-option>
                                <el-option label="致公党党员" value="致公党党员">致公党党员</el-option>
                                <el-option label="九三学社社员" value="九三学社社员">九三学社社员</el-option>
                                <el-option label="台盟盟员" value="台盟盟员">台盟盟员</el-option>
                                <el-option label="无党派人士" value="无党派人士">无党派人士</el-option>
                                <el-option label="群众" value="群众">群众</el-option>
                                <el-option label="其他" value="其他">其他</el-option>
                            </el-select>
                        </div>
                    </div>
                    <!-- 民族 -->
                    <div class="input-row-wrapper highest-degree-wrapper">
                        <div class="input-row-left">
                            <label>民&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;族</label>
                        </div>
                        <div class="layui-input-inline" style="margin-left: 0;padding-top: 13px;">
                            <el-select v-model="nation" placeholder="请选择活动区域">
                                <el-option label="请选择" value=""></el-option>
                                <el-option label="汉族" value="汉族"></el-option>
                                <el-option label="蒙古族" value="蒙古族"></el-option>
                                <el-option label="回族" value="回族"></el-option>
                                <el-option label="藏族" value="藏族"></el-option>
                                <el-option label="维吾尔族" value="维吾尔族"></el-option>
                                <el-option label="苗族" value="苗族"></el-option>
                                <el-option label="彝族" value="彝族"></el-option>
                                <el-option label="壮族" value="壮族"></el-option>
                                <el-option label="布依族" value="布依族"></el-option>
                                <el-option label="朝鲜族" value="朝鲜族"></el-option>
                                <el-option label="满族" value="满族"></el-option>
                                <el-option label="侗族" value="侗族"></el-option>
                                <el-option label="瑶族" value="瑶族"></el-option>
                                <el-option label="白族" value="白族"></el-option>
                                <el-option label="土家族" value="土家族"></el-option>
                                <el-option label="哈尼族" value="哈尼族"></el-option>
                                <el-option label="哈萨克族" value="哈萨克族"></el-option>
                                <el-option label="傣族" value="傣族"></el-option>
                                <el-option label="黎族" value="黎族"></el-option>
                                <el-option label="傈僳族" value="傈僳族"></el-option>
                                <el-option label="佤族" value="佤族"></el-option>
                                <el-option label="畲族" value="畲族"></el-option>
                                <el-option label="高山族" value="高山族"></el-option>
                                <el-option label="拉祜族" value="拉祜族"></el-option>
                                <el-option label="水族" value="水族"></el-option>
                                <el-option label="东乡族" value="东乡族"></el-option>
                                <el-option label="纳西族" value="纳西族"></el-option>
                                <el-option label="景颇族" value="景颇族"></el-option>
                                <el-option label="柯尔克孜族" value="柯尔克孜族"></el-option>
                                <el-option label="土族" value="土族"></el-option>
                                <el-option label="达斡尔族" value="达斡尔族"></el-option>
                                <el-option label="仫佬族" value="仫佬族"></el-option>
                                <el-option label="羌族" value="羌族"></el-option>
                                <el-option label="布朗族" value="布朗族"></el-option>
                                <el-option label="撒拉族" value="撒拉族"></el-option>
                                <el-option label="毛南族" value="毛南族"></el-option>
                                <el-option label="仡佬族" value="仡佬族"></el-option>
                                <el-option label="锡伯族" value="锡伯族"></el-option>
                                <el-option label="阿昌族" value="阿昌族"></el-option>
                                <el-option label="普米族" value="普米族"></el-option>
                                <el-option label="普米族" value="普米族"></el-option>
                                <el-option label="塔吉克族" value="塔吉克族"></el-option>
                                <el-option label="怒族" value="怒族"></el-option>
                                <el-option label="乌孜别克族" value="乌孜别克族"></el-option>
                                <el-option label="俄罗斯族" value="俄罗斯族"></el-option>
                                <el-option label="鄂温克族" value="鄂温克族"></el-option>
                                <el-option label="德昂族" value="德昂族"></el-option>
                                <el-option label="保安族" value="保安族"></el-option>
                                <el-option label="裕固族" value="裕固族"></el-option>
                                <el-option label="京族" value="京族"></el-option>
                                <el-option label="塔塔尔族" value="塔塔尔族"></el-option>
                                <el-option label="独龙族" value="独龙族"></el-option>
                                <el-option label="鄂伦春族" value="鄂伦春族"></el-option>
                                <el-option label="赫哲族" value="赫哲族"></el-option>
                                <el-option label="门巴族" value="门巴族"></el-option>
                                <el-option label="珞巴族" value="珞巴族"></el-option>
                                <el-option label="基诺族" value="基诺族"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="personal-info-setting-save-btn-wrapper">
                    <div class="input-row-left">
                        <label class=""></label>
                    </div>
                    <div class="input-row-right">
                        <div class="layui-input-block" style="margin-left: 0;">
                            <a class="layui-btn layui-btn-normal layui-btn-sm" @click="InstantlySave">立即保存</a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        compoents: {

        },
        data() {
            return {
                action: '',
                actionCardImageUrl:'',
                headPath: '',//头像
                headPathByValue: '',
                userName: '',//姓名
                telephone: '', //手机账号
                idCard: '',//身份证号
                idCardFront: '',//身份证国徽面
                idCardFrontByValue: '',//身份证国徽面
                idCardReverse: '',//身份证正面
                idCardReverseByValue: '',//身份证正面
                email: '',
                sex: '',//性别
                education: '',
                major: '',
                politic_countenance: '',//政治面貌
                nation: '汉族',//民族
                idCardFrontFlag: false,
                idCardReverseFlag: false
            }
        },
        created() {
            this.$parent.leftBeginAffirm(2)
            this.action = this.serverUrl + '/deUp/uploadUserHeadImage';
            this.actionCardImageUrl = this.serverUrl + '/deUp/uploadUserIdCardImage';
            this.loadData();


        },
        mounted() {

        },
        methods: {
            //头像上传
            successFile(response, file, fileList) {

                this.headPath = this.serverUrl + this.prefiexUrl + response.src;

                this.headPathByValue = response.src;

                this.$message({
                    showClose: true,
                    message: '恭喜你，文件上传成功！',
                    type: 'success'
                });
            },
            //国徽面
            successFileIdCardFront(response, file, fileList) {
                this.idCardFront = this.serverUrl + this.prefiexUrl + response.src;

                this.idCardFrontByValue = response.src;
                this.idCardFrontFlag = false;
                this.$message({
                    showClose: true,
                    message: '恭喜你，文件上传成功！',
                    type: 'success'
                });
            },
            //正面
            successFileIdCardReverse(response, file, fileList) {
                this.idCardReverse = this.serverUrl + this.prefiexUrl + response.src;
                this.idCardReverseByValue = response.src;
                this.idCardReverseFlag = false;
                this.$message({
                    showClose: true,
                    message: '恭喜你，文件上传成功！',
                    type: 'success'
                });
            },
            loadData() {
                let parames = new URLSearchParams();
                parames.append('idCard', this.$storage.get('declareUser').idCard);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/getDeclareUserData', parames).then(resp => {
                    //this.serverUrl
                    this.headPath = this.serverUrl + this.prefiexUrl + resp.data.data.headPath;

                    this.headPathByValue = resp.data.data.headPath;

                    this.userName = resp.data.data.userName;

                    this.telephone = resp.data.data.telephone;

                    this.idCard = resp.data.data.idCard;

                    if (resp.data.data.idCardFront == null || resp.data.data.idCardFront == '') {
                        this.idCardFrontFlag = true;
                    } else {
                        this.idCardFront = this.serverUrl + this.prefiexUrl + resp.data.data.idCardFront;
                        this.idCardFrontByValue = resp.data.data.idCardFront;
                    }
                    if (resp.data.data.idCardReverse == null || resp.data.data.idCardReverse == '') {
                        this.idCardReverseFlag = true;
                    } else {
                        this.idCardReverse = this.serverUrl + this.prefiexUrl + resp.data.data.idCardReverse;
                        this.idCardReverseByValue = resp.data.data.idCardReverse;
                    }
                    this.email = resp.data.data.email;
                    this.sex = resp.data.data.sex.toString();
                    this.education = resp.data.data.education;
                    this.major = resp.data.data.major;
                    this.politic_countenance = resp.data.data.politic_countenance;
                    this.nation = resp.data.data.nation;
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })

            },
            InstantlySave() {

                let parames = new URLSearchParams();
                parames.append('id', this.$storage.get('declareUser').id);
                parames.append('headPath', this.headPathByValue);
                parames.append('userName', this.userName);
                parames.append('telephone', this.telephone);
                parames.append('idCardFront', this.idCardFrontByValue);
                parames.append('idCardReverse', this.idCardReverseByValue);
                parames.append('email', this.email);
                parames.append('sex', this.sex);
                parames.append('education', this.education);
                parames.append('major', this.major);
                parames.append('politic_countenance', this.politic_countenance);
                parames.append('nation', this.nation);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/updateUserInfo', parames).then(resp => {
                    this.$message({
                        showClose: true,
                        message: '保存成功！',
                        type: 'success'
                    });

                    setTimeout(() => {   //设置延迟执行
                        this.loadData();
                    }, 1500);

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })

            }
        }

    }
</script>

<style scoped>
  
    div /deep/ .el-upload-dragger {
        background-color: #fff;
        border: 0px dashed #d9d9d9 !important;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: auto !important;
        height: auto !important;
        text-align: inherit !important;
        position: relative;
        overflow: hidden;
    }

    .el-radio__input.is-checked+.el-radio__label {
        color: #5FB878;
    }

    .el-radio__input.is-checked .el-radio__inner {
        border-color: #5FB878;
        background: #5FB878;
    }

    select {
        display: none;
    }

    .layui-edge {
        display: inline-block;
        width: 0;
        height: 0;
        border-width: 6px;
        border-style: dashed;
        border-color: transparent;
    }

    .layui-form-select .layui-edge {
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -3px;
        cursor: pointer;
        border-width: 6px;
        border-top-color: #c2c2c2;
        border-top-style: solid;
        transition: all .3s;
        -webkit-transition: all .3s;
    }

    .layui-form-select dl dd,
    .layui-form-select dl dt {
        padding: 0 10px;
        line-height: 36px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .layui-form-select dl dd {
        cursor: pointer;
    }

    .layui-form-select dl dd.layui-this {
        background-color: #5FB878;
        color: #fff;
    }

    .layui-form-select dl dd.layui-select-tips {
        padding-left: 10px !important;
        color: #999;
    }

    dl {
        display: none;
        position: absolute;
        left: 0;
        top: 42px;
        padding: 5px 0;
        z-index: 899;
        min-width: 100%;
        border: 1px solid #d2d2d2;
        max-height: 300px;
        overflow-y: auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
        box-sizing: border-box;
    }

    .layui-input,
    .layui-textarea {
        display: block;
        width: 100%;
        padding-left: 10px;
        height: 38px;
        line-height: 1.3;
        line-height: 38px\9;
        border-width: 1px;
        border-style: solid;
        background-color: #fff;
        border-radius: 2px;
    }

    .layui-form-select .layui-input {
        padding-right: 30px;
        cursor: pointer;
    }

    .layui-form-label,
    .layui-form-mid,
    .layui-form-select,
    .layui-input-block,
    .layui-input-inline,
    .layui-textarea {
        position: relative;
    }

    .layui-input-inline {
        display: inline-block;
        vertical-align: middle;
    }

    button,
    input,
    optgroup,
    option,
    select,
    textarea {
        font-family: inherit;
        font-size: inherit;
        font-style: inherit;
        font-weight: inherit;
        outline: 0;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .layui-btn-normal {
        background-color: #1E9FFF;
    }

    .layui-btn-sm {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        font-size: 12px;
    }

    .layui-anim.layui-icon {
        display: inline-block;
    }

    .layui-form-radio>i {
        margin-right: 8px;
        font-size: 22px;
        color: #c2c2c2;
    }

    .layui-form-radio {
        display: inline-block;
        vertical-align: middle;
        line-height: 28px;
        margin: 6px 10px 0 0;
        padding-right: 10px;
        cursor: pointer;
        font-size: 0;
    }

    .layui-input-block {
        margin-left: 110px;
        min-height: 36px;
    }

    .ux-input_base {
        padding: .16rem .32rem;
        font-size: 14px;
        border: 1px solid #ddd;
        color: #555;
        background: #fff;
        border-radius: 2px;
        vertical-align: middle;
    }

    .ux-input2,
    .ux-textarea2 {
        display: inline-block;
        position: relative;
        white-space: nowrap;
    }

    .userInfo .layui-icon-tips {
        font-size: 13px;
    }

    .layui-show {
        display: block !important;
    }

    .layui-upload-drag .layui-icon {
        font-size: 50px;
        color: #009688;
    }

    .layui-upload-file {
        display: none !important;
        opacity: .01;
        filter: Alpha(opacity=1);
    }

    .layui-upload-drag {
        position: relative;
        padding: 30px;
        border: 1px dashed #e2e2e2;
        background-color: #fff;
        text-align: center;
        cursor: pointer;
        color: #999;
    }

    .layui-upload-drag {
        border: 1px solid #5fb878;
    }

    .layui-icon {
        font-family: layui-icon !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .userInfo .layui-icon-tips {
        font-size: 13px;
    }

    .input-row-right input[type="text"] {
        width: 400px;
        height: 30px;
    }

    .ux-input2,
    .ux-textarea2 {
        display: inline-block;
        position: relative;
        white-space: nowrap;
    }

    .profile-image-upload {
        text-align: center;
        position: relative;
        vertical-align: top;
        display: inline-block;
        border-radius: 50%;
        width: 104px;
        height: 104px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url(/jnrd/img/profile-image.png);
    }

    .input-row-right {
        font-size: 12px;
        width: 690px;
        text-align: left;
        display: inline-block;
        vertical-align: top;
        text-align: left;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .input-row-left {
        width: 160px;
        text-align: left;
        padding-left: 50px;
        display: inline-block;
        vertical-align: top;
        text-align: left;
        padding-top: 20px;
        padding-bottom: 20px;
        margin-right: 30px;
        font-weight: 600;
    }

    .f-cb:after {
        display: block;
        clear: both;
        visibility: hidden;
        height: 0;
        overflow: hidden;
        content: ".";
    }

    .layui-card-body {
        position: relative;
        padding: 10px 15px;
        line-height: 24px;
    }

    .layui-card-header {
        position: relative;
        height: 42px;
        line-height: 42px;
        padding: 0 15px;
        border-bottom: 1px solid #f6f6f6;
        color: #333;
        border-radius: 2px 2px 0 0;
        font-size: 14px;
    }

    .u-gx-ttop {
        border-bottom: none;
        margin: 0 15px;
        height: 38px;
        padding: 10px 0;
    }

    .f-fc9 {
        color: #999;
    }

    .f-f0 {
        font-family: "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
    }

    .f-fl {
        float: left;
    }

    div /deep/ .el-upload__input {
        display: none !important;
    }

    input[type=file] {
        display: none !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/affirm/personalInformation.vue